export default function (context) {
  context.$axios.onError((error) => {
    if (error.response !== undefined && error.response.status === 401) {
      return Promise.reject(error)
    }
  })
}
